import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=56e214b0"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports